import { useUser } from "@clerk/clerk-react";


// Helper function to set user in localStorage
export const setUser = (user) => {
    const existingUser = getUser();

    if (existingUser?.id === user?.id) {
        return;
    }

    localStorage.setItem('user', JSON.stringify(user));

    if (window.pendo) {
        window.pendo?.initialize({
            visitor: {
                id: user?.id,
                email: user?.primaryEmailAddress?.email,
                first_name: user?.firstName,
                last_name: user?.lastName,
                role: user?.publicMetadata?.role,
            },
            account: {
                id: user?.publicMetadata?.company_id,
            }
        });
    }
};

export const removeUser = () => {
    localStorage.removeItem('user');
}

// Helper function to get user from localStorage
export const getUser = () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
};

// Helper function to check if the user is an admin
export const useIsUserAdmin = () => {
    const { user } = useUser();

    if (!user) {
        return false;
    }

    return user?.publicMetadata?.role === 'admin';
};

// Helper function to get the user's company ID
export const getUserCompanyId = () => {
    const user = getUser();
    return user?.publicMetadata?.company_id || null;
};